var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Callout, Card, checkIsPlatform, Collapsible, Divider, isValidObject, LILAC_200, LILAC_400, Loader, useBreakpoint, WHITE } from '@airtel/air-design-system';
import { useEffect, useRef, useState } from 'react';
import { Keyboard, View } from 'react-native';
import { FormWidgetComponent } from '../form-widget/FormWidget';
import { LinkListItemWidget } from '../link-list-item-widget';
import { OmniWidget } from '../omni-widget';
import { PlanListWidget } from '../plan-list-widget';
import { getStepWidgetStyles } from './StepCardWidgetStyles';
import { createArrayOfInputLabels, getSubHeading } from './StepCardWidgetUtils';
export var StepCardWidgetComponent = props => {
  var _props$showContentDiv = props.showContentDivider,
    showContentDivider = _props$showContentDiv === void 0 ? true : _props$showContentDiv,
    _props$dynamicFieldsP = props.dynamicFieldsProps,
    dynamicFieldsProps = _props$dynamicFieldsP === void 0 ? {} : _props$dynamicFieldsP,
    dynamicFormButtonDisabled = props.dynamicFormButtonDisabled,
    errorValues = props.errorValues,
    _props$isLoading = props.isLoading,
    isLoading = _props$isLoading === void 0 ? false : _props$isLoading,
    _props$listData = props.listData,
    listData = _props$listData === void 0 ? {} : _props$listData,
    _props$isExpanded = props.isExpanded,
    isExpanded = _props$isExpanded === void 0 ? false : _props$isExpanded,
    _onUserAction = props.onUserAction,
    _props$onListItemPres = props.onListItemPress,
    onListItemPress = _props$onListItemPres === void 0 ? {} : _props$onListItemPres,
    onToggleMetaData = props.onToggleMetaData,
    id = props.id,
    _props$formWidgetData = props.formWidgetData,
    formWidgetData = _props$formWidgetData === void 0 ? {} : _props$formWidgetData,
    _props$disableToggle = props.disableToggle,
    disableToggle = _props$disableToggle === void 0 ? false : _props$disableToggle,
    _props$initialOpen = props.initialOpen,
    initialOpen = _props$initialOpen === void 0 ? false : _props$initialOpen,
    _props$removeOverflow = props.removeOverflow,
    removeOverflow = _props$removeOverflow === void 0 ? false : _props$removeOverflow,
    _props$omniWidgetData = props.omniWidgetData,
    omniWidgetData = _props$omniWidgetData === void 0 ? {} : _props$omniWidgetData,
    style = props.style,
    onValidFormMetaData = props.onValidFormMetaData,
    _props$isValidFormCal = props.isValidFormCallWithDebounce,
    isValidFormCallWithDebounce = _props$isValidFormCal === void 0 ? false : _props$isValidFormCal,
    onInValidFormMetaData = props.onInValidFormMetaData,
    _props$isInValidFormC = props.isInValidFormCallWithDebounce,
    isInValidFormCallWithDebounce = _props$isInValidFormC === void 0 ? false : _props$isInValidFormC,
    _props$debounceDelay = props.debounceDelay,
    debounceDelay = _props$debounceDelay === void 0 ? 800 : _props$debounceDelay,
    _props$planListWidget = props.planListWidgetData,
    planListWidgetData = _props$planListWidget === void 0 ? {} : _props$planListWidget,
    _props$showPackSelect = props.showPackSelection,
    showPackSelection = _props$showPackSelect === void 0 ? true : _props$showPackSelect,
    _props$showStepAction = props.showStepActionCta,
    showStepActionCta = _props$showStepAction === void 0 ? false : _props$showStepAction,
    _props$backgroundColo = props.backgroundColor,
    backgroundColor = _props$backgroundColo === void 0 ? LILAC_200 : _props$backgroundColo,
    calloutProps = props.calloutProps,
    loaderProps = props.loaderProps,
    subHeadingDataFields = props.subHeadingDataFields,
    showLoader = props.showLoader,
    restProps = __rest(props, ["showContentDivider", "dynamicFieldsProps", "dynamicFormButtonDisabled", "errorValues", "isLoading", "listData", "isExpanded", "onUserAction", "onListItemPress", "onToggleMetaData", "id", "formWidgetData", "disableToggle", "initialOpen", "removeOverflow", "omniWidgetData", "style", "onValidFormMetaData", "isValidFormCallWithDebounce", "onInValidFormMetaData", "isInValidFormCallWithDebounce", "debounceDelay", "planListWidgetData", "showPackSelection", "showStepActionCta", "backgroundColor", "calloutProps", "loaderProps", "subHeadingDataFields", "showLoader"]);
  var _listData$actionTypeO = listData.actionTypeOnPressMetaData,
    actionTypeOnPressMetaData = _listData$actionTypeO === void 0 ? {} : _listData$actionTypeO,
    _listData$metaInfoCta = listData.metaInfoCtaPressMetaData,
    metaInfoCtaPressMetaData = _listData$metaInfoCta === void 0 ? {} : _listData$metaInfoCta,
    _listData$infoIconPre = listData.infoIconPressMetaData,
    infoIconPressMetaData = _listData$infoIconPre === void 0 ? {} : _listData$infoIconPre,
    _listData$onRefreshCt = listData.onRefreshCtaTimerCompleteMetaData,
    onRefreshCtaTimerCompleteMetaData = _listData$onRefreshCt === void 0 ? {} : _listData$onRefreshCt;
  var _formWidgetData$field = formWidgetData.fields,
    fields = _formWidgetData$field === void 0 ? [] : _formWidgetData$field;
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var _useState = useState(isExpanded),
    internalIsExpanded = _useState[0],
    setInternalIsExpanded = _useState[1];
  var stepCardWidgetStyles = getStepWidgetStyles(isSmallScreen, internalIsExpanded, props);
  var _useState2 = useState(removeOverflow),
    _removeOverflow = _useState2[0],
    _setRemoveOverflow = _useState2[1];
  var _useState3 = useState(listData === null || listData === void 0 ? void 0 : listData.subHeading),
    subHeading = _useState3[0],
    setSubHeading = _useState3[1];
  var _useState4 = useState(false),
    hideContent = _useState4[0],
    sethideContent = _useState4[1];
  var inputLabelsRef = useRef([]);
  var selectedRadioLabelRef = useRef('');
  var collapsibleTogglerRef = useRef();
  useEffect(() => {
    _setRemoveOverflow(removeOverflow);
  }, [removeOverflow]);
  useEffect(() => {
    setSubHeading(listData === null || listData === void 0 ? void 0 : listData.subHeading);
  }, [listData === null || listData === void 0 ? void 0 : listData.subHeading]);
  useEffect(() => {
    var labels = createArrayOfInputLabels(fields, subHeadingDataFields);
    inputLabelsRef.current = labels;
  }, [JSON.stringify(fields)]);
  useEffect(() => {
    var _a;
    (_a = collapsibleTogglerRef === null || collapsibleTogglerRef === void 0 ? void 0 : collapsibleTogglerRef.current) === null || _a === void 0 ? void 0 : _a.toggle(isExpanded);
    setInternalIsExpanded(isExpanded);
  }, [isExpanded]);
  useEffect(() => {
    setTimeout(() => {
      sethideContent(internalIsExpanded);
    }, !internalIsExpanded ? 200 : 0);
    if (!internalIsExpanded) {
      Keyboard === null || Keyboard === void 0 ? void 0 : Keyboard.dismiss();
    }
  }, [internalIsExpanded]);
  var handleClick = () => {
    var _a;
    if (!disableToggle) {
      (_a = collapsibleTogglerRef === null || collapsibleTogglerRef === void 0 ? void 0 : collapsibleTogglerRef.current) === null || _a === void 0 ? void 0 : _a.toggle();
    }
  };
  var handleUserAction = data => {
    setSubHeading(prevSubHeading => getSubHeading({
      data,
      inputLabelsRef,
      selectedRadioLabelRef,
      prevSubHeading,
      subHeadingDataFields
    }));
  };
  var showActionProps = !internalIsExpanded && (showStepActionCta || !!subHeading || isValidObject(omniWidgetData));
  var showSubheading = !internalIsExpanded && !!subHeading;
  var formWidgetDataForStep = Object.assign(Object.assign({}, formWidgetData), {
    dynamicFieldsProps,
    dynamicFormButtonDisabled,
    errorValues,
    onValidFormMetaData,
    isValidFormCallWithDebounce,
    debounceDelay,
    onInValidFormMetaData,
    isInValidFormCallWithDebounce
  });
  return _jsx(_Fragment, {
    children: isValidObject(listData) && _jsx(Card, Object.assign({
      style: [stepCardWidgetStyles.stepCard, style],
      noPadding: true
    }, restProps, {
      children: _jsxs(Collapsible, Object.assign({
        childPaddingToken: "SPACING_0",
        disabled: disableToggle,
        initialOpen: initialOpen,
        showIcon: false,
        removeOverflow: _removeOverflow,
        collapseContainerStyles: stepCardWidgetStyles.collapsibleContainer,
        ref: collapsibleTogglerRef,
        onToggleHandler: state => {
          onToggleMetaData && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
            id
          }, onToggleMetaData), {
            isExpanded: state
          }));
          setInternalIsExpanded(state);
        },
        titleNoHorizontalPadding: true,
        titleNoVerticalPadding: true,
        titleComponent: _jsxs(View, Object.assign({
          style: stepCardWidgetStyles.titleComponent
        }, {
          children: [_jsx(LinkListItemWidget, Object.assign({}, listData, {
            noHoverEffect: true,
            noPressEffect: true,
            actionTypeProps: showActionProps && (listData === null || listData === void 0 ? void 0 : listData.actionTypeProps),
            subHeading: showSubheading && subHeading,
            onPress: onListItemPress,
            actionTypeOnPressMetaData: actionTypeOnPressMetaData,
            metaInfoCtaPressMetaData: metaInfoCtaPressMetaData,
            infoIconPressMetaData: infoIconPressMetaData,
            onRefreshCtaTimerCompleteMetaData: onRefreshCtaTimerCompleteMetaData,
            style: stepCardWidgetStyles.linkListWidget,
            onUserAction: (action, actionContextData) => {
              var actionPayload = action;
              isValidObject(actionPayload) && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
                id
              }, actionPayload), actionContextData));
              handleClick();
            }
          })), isValidObject(calloutProps) && _jsx(Callout, Object.assign({}, calloutProps, {
            style: [stepCardWidgetStyles.calloutContainer, calloutProps === null || calloutProps === void 0 ? void 0 : calloutProps.style]
          }))]
        }))
      }, {
        children: [showContentDivider && _jsx(Divider, {
          color: LILAC_400,
          shadowColor: WHITE,
          height: 2
        }), _jsxs(View, Object.assign({
          style: [stepCardWidgetStyles.content, isValidObject(omniWidgetData) && stepCardWidgetStyles.omni, isValidObject(planListWidgetData) && stepCardWidgetStyles.planList]
        }, {
          children: [isValidObject(formWidgetData) && _jsx(View, Object.assign({
            pointerEvents: internalIsExpanded ? 'auto' : 'none',
            style: checkIsPlatform('web') && {
              visibility: hideContent ? 'visible' : 'hidden'
            }
          }, {
            children: _jsx(FormWidgetComponent, Object.assign({}, formWidgetDataForStep, {
              isLoading: isLoading,
              onUserAction: (action, data, callback) => {
                action && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(action, data, callback));
                handleUserAction(data);
              }
            }))
          })), isValidObject(omniWidgetData) && _jsx(OmniWidget, Object.assign({}, omniWidgetData, {
            onUserAction: _onUserAction,
            onModalToggle: _ref => {
              var open = _ref.open;
              if (open) {
                _setRemoveOverflow(true);
              } else {
                _setRemoveOverflow(removeOverflow);
              }
            }
          })), showLoader && _jsx(Loader, Object.assign({}, loaderProps)), isValidObject(planListWidgetData) && _jsx(PlanListWidget, Object.assign({}, planListWidgetData, {
            numOfCardSTobeShownPerRow: !isSmallScreen ? 2 : 1,
            showPackDivider: isSmallScreen,
            commonPlanCardProps: Object.assign({}, isSmallScreen && {
              cardBorderWidth: 0,
              withRoundedBorder: false
            }),
            showPackSelection: showPackSelection,
            packCardBackgroundColor: backgroundColor,
            onUserAction: _onUserAction
          }))]
        }))]
      }))
    }))
  });
};
StepCardWidgetComponent.genericRendererKey = 'AirStepCardWidget';